import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';

export const TargetKpiSelect = ({ codeToKpi, fieldDef }) => {
  const { formValues } = useForm();

  if (formValues.valueDistributionMode !== 'RATIO') {
    return null;
  }

  const updatedFieldDef = {
    ...fieldDef,
    values: Object.values(codeToKpi).map(kpi => {
      return { code: kpi.code, displayName: kpi.displayName };
    })
  };

  return (
    <EnumSelect fieldDef={updatedFieldDef} />
  )
}